/**
 * BE-186 — the step a quiz was left at, on the account: `GET | PUT | DELETE /user/quiz-progress/{kind}`
 * (one row per user and kind, 30-day TTL — expired is a 404 like never saved). The draft is the
 * quiz's own JSON; bodies pass through the case interceptor, so `answers_draft` is `answersDraft` here
 * and the draft's keys must be words the camel ⇄ snake transform leaves alone.
 */
import { apiClient } from '@/api/api'

export type QuizProgressKind = 'sizes' | 'style' | 'lifestyle' | 'outfit' | 'gift'

export interface QuizProgress<Draft = Record<string, unknown>> {
  kind: QuizProgressKind
  step: string | null
  answersDraft: Draft
  updatedAt: string
  expiresAt: string
}

export interface QuizProgressBody<Draft = Record<string, unknown>> {
  /** ≤ 64 characters */
  step?: string | null
  answersDraft: Draft
}

/** 404 when nothing is saved or the row expired. */
export const getQuizProgress = <Draft = Record<string, unknown>>(kind: QuizProgressKind) =>
  apiClient.get<QuizProgress<Draft>>(`/user/quiz-progress/${kind}`)

export const putQuizProgress = <Draft = Record<string, unknown>>(kind: QuizProgressKind, body: QuizProgressBody<Draft>) =>
  apiClient.put<QuizProgress<Draft>>(`/user/quiz-progress/${kind}`, body)

export const deleteQuizProgress = (kind: QuizProgressKind) =>
  apiClient.delete<{ kind: QuizProgressKind; deleted: number }>(`/user/quiz-progress/${kind}`)
